module.exports = require('./lib/linkify-string');



/*****************
 ** WEBPACK FOOTER
 ** ./~/linkifyjs/string.js
 ** module id = 482
 ** module chunks = 0
 **/